import { Component, OnInit } from '@angular/core';
import { AdobeLaunchService } from '../shared/services/adobe-launch.service';

@Component({
  selector: 'testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit {

  constructor(
        private readonly adobeLaunchService: AdobeLaunchService
    ) {
    }

  ngOnInit(): void {
    document.documentElement.classList.add('default-font-size');
    this.adobeLaunchService.trackPageView({
      pageTitle:'Testimonials'
    });
  }

}
